import {
  fetchAll,
  createDocWithId,
  updateDocById,
  deleteDocById,
} from "./firestoreHelpers";

const COLL = "alquileres_pagos";

export const getPagos = async () => fetchAll(COLL);

// For the volume we expect (~hundreds/year), client-side filtering is simpler
// than maintaining composite indexes. AlquileresContext caches the full list.
export const getPagosByMes = async (mes, anio) => {
  const all = await fetchAll(COLL);
  return all.filter((p) => p.mes === mes && p.anio === anio);
};

export const getPagosByContrato = async (contratoId) => {
  const all = await fetchAll(COLL);
  return all.filter((p) => p.contratoId === contratoId);
};

export const savePago = async (data) => createDocWithId(COLL, data);

export const updatePago = async (id, data) => updateDocById(COLL, id, data);

export const deletePago = async (id) => deleteDocById(COLL, id);
